<template>
  <div>
    <modal-header>Add Password to Room</modal-header>
    <div class="body">
      Adding a password will enable guest invitees to skip the lobby and enter a password to join.
      <br/><br/>
      This password is <span class="underline">one time view only</span>, make sure this is copied before saving. Space members will also be asked to enter a password to join the room.
    </div>
    <TextInput inset label="Create password" placeholder="Type a password" v-model="password"/>
    <FooterButtons>
        <btn @onClick="cancel" colour="ghost"> <template #text>Cancel</template></btn>
        <btn @onClick="save" :disabled="!isValid" colour="green"> <template #text>Save</template></btn>
    </FooterButtons>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import ModalHeader from '@/framework/modals/components/newModalHeader.vue'
import { TextInput, FooterButtons } from "@/framework"

export default {
  components: { ModalHeader, TextInput, FooterButtons },
  name: 'AddPasswordModal',
  data() {
    return {
        password: ''
    };
  },
  props: {
    onCancel: Function,
    onSave: Function
  },
  computed: {
    ...mapGetters(['getSpacePageId']),
    isValid() {
      return this.password.length > 0;
    }
  },
  methods: {
    ...mapActions(['modal/close', 'handleAddRoomPassword']),
    cancel() {
      this.onCancel()
      this['modal/close']()
    },

    async save() {
      let res = await this['handleAddRoomPassword']([this.getSpacePageId,this.password])
      this.onSave(res)
      this['modal/close']()
    }
  },
  created() {
    this.$emit('modalSettings', {
      hasCloseButton: false
    })
  }
};
</script>

<style scoped lang="scss">
.body {
  margin-bottom: 20px;
  color: $grey-1;
}

.underline {
  text-decoration: underline;
}
</style>
